import { render } from "./CliPaymentConfirmationTab.vue?vue&type=template&id=17aee354&ts=true"
import script from "./CliPaymentConfirmationTab.vue?vue&type=script&lang=ts"
export * from "./CliPaymentConfirmationTab.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__